import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {QbCustomerMsgDto} from "../model/QbCustomerMsgDto";
import {DisposeBag} from "../modules/DisposeBag";

class QbCustomerMsgSelectController implements IComponentController {
    records: QbCustomerMsgDto[] = [];
    model: any;
    onSelect: Function;
    required: string;
    placeholder: string;
    showAll: Boolean;
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.bindAllQbCustomerMsg(() => this.records, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }

    reload = () => {
        this.$dataHub.qbCustomerMsgSubscribeAndQuery().then(ret=>this.records=ret);
    };

    $onInit(): void {
        this.showAll = this.showAll || false;
    }
    $onDestroy() {
        this.disposeBag.finalize();
    }
}

export default angular.module('component.qbCustomerMsgSelect', [])
    .component('qbCustomerMsgSelect', {
        template: require('./QbCustomerMsgSelect.html'),
        controller: QbCustomerMsgSelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '='
        }
    }).name;
